import { app } from '../../../../../app';
import { Controller } from './idp-authenticator-config.controller';

app.component('companyIdpAuthenticatorsManageConfig', {
    bindings: {
        companyId: '<',
        idpAuthenticator: '<',
        idpAuthenticators: '<',
    },
    controller: Controller,
    templateUrl: require('./idp-authenticator-config.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/manage/config/idp-authenticator-config.component.js